<script lang="ts">
	import { T } from "@tolgee/svelte";
	import { VERSION } from "$env";
	import ErrorIcon from "./assets/icons/Error.svg#icon";
	import { ButtonVariant, ButtonVisualStyle } from "./components/buttons/Button";
	import Button from "./components/buttons/Button.svelte";
	import ErrorDetails from "./components/utility/ErrorDetails.svelte";
	import { globalState } from "./state/globalState.svelte";
	import { isOutdatedBrowser } from "./utils/isOutdatedBrowser";

	const {
		error,
		messages,
		reset,
	}: {
		error: unknown;
		reset(this: void): void;
		messages?: {
			error: string;
			outdatedApp: string;
			outdatedBrowser: string;
			restartApp: string;
		};
	} = $props();
</script>

<div class="grid min-h-full place-items-center px-4 py-12">
	<div
		class="w-full max-w-lg space-y-6 rounded-3xl border border-red-200 bg-red-50 p-8 shadow-lg sm:max-w-xl md:max-w-2xl md:p-10 lg:max-w-3xl"
	>
		<div class="flex items-center gap-4">
			<div class="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-red-100 md:size-14">
				<ErrorIcon class="size-6 text-red-600 md:size-7" />
			</div>
			<div class="min-w-0 flex-1">
				<h1 class="text-xl font-bold text-red-900 md:text-2xl lg:text-3xl">
					{#if messages}
						{messages.error}
					{:else}
						<T keyName="error.unexpected" />
					{/if}
				</h1>
				{#if globalState.newestVersion !== VERSION}
					<p class="mt-1 text-sm text-red-700">
						{#if messages}
							{messages.outdatedApp}
						{:else}
							<T keyName="error.outdatedApp" />
						{/if}
					</p>
				{/if}
				{#if !globalState.userAgent || isOutdatedBrowser(globalState.userAgent)}
					<p class="mt-1 text-sm text-red-700">
						{#if messages}
							{messages.outdatedBrowser}
						{:else}
							<T keyName="outdatedBrowser.onError" />
						{/if}
					</p>
				{/if}
			</div>
		</div>

		<div class="rounded-2xl border border-red-100 bg-white/60 p-4">
			<ErrorDetails {error} />
		</div>

		<Button variant={ButtonVariant.Error} visualStyle={ButtonVisualStyle.Filled} onclick={reset}>
			{#if messages}
				{messages.restartApp}
			{:else}
				<T keyName="error.restartApp" />
			{/if}
		</Button>
	</div>
</div>
